import templateStr from 'text!./templates/question-set.html';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            'gwPlQuestionSet': '='
        },
        controller: ['$scope', 'QuestionSetService', function ($scope, QuestionSetService) {
            $scope.questionSets = QuestionSetService.getQuestionSetViewModel($scope.gwPlQuestionSet);
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-angular/QuestionSetDirective.js
// module id = 898
// module chunks = 0